/**
 * Custom hook connecting game core state to React
 * core.on('stateChanged') → useSyncExternalStore pattern
 */

import { useCallback, useSyncExternalStore } from 'react';
import type { GameCore } from '@app-games/core';
import type { GameState, GameAction } from '../game/index.js';

export function useGameState(core: GameCore<GameState, GameAction>): Readonly<GameState> {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      const unsub1 = core.on('stateChanged', onStoreChange);
      const unsub2 = core.on('tick', onStoreChange);
      return () => { unsub1(); unsub2(); };
    },
    [core]
  );

  const getSnapshot = useCallback(() => core.getState(), [core]);

  return useSyncExternalStore(subscribe, getSnapshot);
}
